import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navigation from './components/Navigation';
import HeaderMessage from './components/HeaderMessage';
import MaintenanceScreen from './components/MaintenanceScreen';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import CategoryPage from './pages/CategoryPage';
import Products from './pages/Products';
import Register from './pages/Register';
import Login from './pages/Login';
import Checkout from './pages/Checkout';
import Privacy from './pages/Privacy';
import About from './pages/About';
import Terms from './pages/Terms';
import ShippingWarranty from './pages/ShippingWarranty';
import Cookies from './pages/Cookies';
import Withdrawal from './pages/Withdrawal';
import PriceList from './pages/PriceList';
import Account from './pages/Account';
import AccountOrders from './pages/AccountOrders';
import AccountAddresses from './pages/AccountAddresses';
import { CartProvider } from './contexts/CartContext';
import { WarehouseProvider } from './contexts/WarehouseContext';
import Cart from './components/cart/Cart';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  // Maintenance mode ellenőrzés - production környezetben
  const isMaintenanceMode = process.env.NODE_ENV === 'production' && process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  if (isMaintenanceMode) {
    return <MaintenanceScreen />;
  }

  return (
    <WarehouseProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
          <HeaderMessage />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/category/:categoryId" element={<CategoryPage />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/checkout" element={<Checkout />} />
              
              {/* Információs oldalak */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/shipping-warranty" element={<ShippingWarranty />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/withdrawal" element={<Withdrawal />} />
              <Route path="/price-list" element={<PriceList />} />
              
              {/* Fiók oldalak */}
              <Route path="/account" element={<Account />} />
              <Route path="/account/orders" element={<AccountOrders />} />
              <Route path="/account/addresses" element={<AccountAddresses />} />
              <Route path="/account/invoices" element={<div className="min-h-screen bg-gray-50 py-8">
                <div className="container mx-auto px-4">
                  <h1 className="text-3xl font-bold text-gray-800 mb-8">Számlák</h1>
                  <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <p className="text-gray-600">A számlák funkció fejlesztés alatt...</p>
                  </div>
                </div>
              </div>} />
              <Route path="/account/password" element={<div className="min-h-screen bg-gray-50 py-8">
                <div className="container mx-auto px-4">
                  <h1 className="text-3xl font-bold text-gray-800 mb-8">Jelszó megváltoztatása</h1>
                  <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <p className="text-gray-600">A jelszó módosítás funkció fejlesztés alatt...</p>
                  </div>
                </div>
              </div>} />
              <Route path="/account/delete" element={<div className="min-h-screen bg-gray-50 py-8">
                <div className="container mx-auto px-4">
                  <h1 className="text-3xl font-bold text-gray-800 mb-8">Adatok törlése</h1>
                  <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <p className="text-gray-600">Az adattörlés funkció fejlesztés alatt...</p>
                  </div>
                </div>
              </div>} />
              <Route path="/account/data-request" element={<div className="min-h-screen bg-gray-50 py-8">
                <div className="container mx-auto px-4">
                  <h1 className="text-3xl font-bold text-gray-800 mb-8">Adatok lekérése</h1>
                  <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <p className="text-gray-600">Az adatlekérés funkció fejlesztés alatt...</p>
                  </div>
                </div>
              </div>} />
              
              <Route path="/contact" element={<div className="min-h-screen bg-gray-50 py-8">
                <div className="container mx-auto px-4">
                  <h1 className="text-3xl font-bold text-gray-800 mb-8">Kapcsolat</h1>
                  <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <p className="text-gray-600">A kapcsolat funkció fejlesztés alatt...</p>
                  </div>
                </div>
              </div>} />
            </Routes>
          </main>
          <Cart />
          </div>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                style: {
                  background: '#059669',
                },
              },
              error: {
                style: {
                  background: '#DC2626',
                },
              },
            }}
          />
        </Router>
      </CartProvider>
    </WarehouseProvider>
  );
}

export default App;
